/**
 * Compare-accordion chrome colors.
 * Distinct check colors keep Elite vs Prime columns readable without relying
 * on icon shape alone (WCAG non-color cue via check vs lock glyphs too).
 */
export const ELITE_PLANS_COMPARE_PRIME_CHECK_COLOR = '#C4515D'
export const ELITE_PLANS_COMPARE_ELITE_CHECK_COLOR = '#CC5C2D'
